import { initializeDi } from "./di/registry";
initializeDi();

import { LitElement, css, html } from "lit";

import { customElement } from "lit/decorators.js";

import "@phosphor-icons/webcomponents/PhBeerStein";

import "@phosphor-icons/webcomponents/PhCamera";
import "@phosphor-icons/webcomponents/PhCaretRight";
import "@phosphor-icons/webcomponents/PhCaretLeft";
import "@phosphor-icons/webcomponents/PhChartBar";
import "@phosphor-icons/webcomponents/PhCheck";
import "@phosphor-icons/webcomponents/PhCheckCircle";
import "@phosphor-icons/webcomponents/PhCircleNotch";
import "@phosphor-icons/webcomponents/PhDiscordLogo";
import "@phosphor-icons/webcomponents/PhDotsThree";
import "@phosphor-icons/webcomponents/PhEye";
import "@phosphor-icons/webcomponents/PhEyedropper";
import "@phosphor-icons/webcomponents/PhFacebookLogo";
import "@phosphor-icons/webcomponents/PhGear";
import "@phosphor-icons/webcomponents/PhImage";
import "@phosphor-icons/webcomponents/PhImages";
import "@phosphor-icons/webcomponents/PhInstagramLogo";
import "@phosphor-icons/webcomponents/PhLink";
import "@phosphor-icons/webcomponents/PhLinkedinLogo";
import "@phosphor-icons/webcomponents/PhMoon";
import "@phosphor-icons/webcomponents/PhPencilLine";
import "@phosphor-icons/webcomponents/PhPinterestLogo";
import "@phosphor-icons/webcomponents/PhPlus";
import "@phosphor-icons/webcomponents/PhPlusCircle";
import "@phosphor-icons/webcomponents/PhQuestion";
import "@phosphor-icons/webcomponents/PhSealPercent";
import "@phosphor-icons/webcomponents/PhSignOut";
import "@phosphor-icons/webcomponents/PhSnapchatLogo";
import "@phosphor-icons/webcomponents/PhSoundcloudLogo";
import "@phosphor-icons/webcomponents/PhSpinner";
import "@phosphor-icons/webcomponents/PhSpotifyLogo";
import "@phosphor-icons/webcomponents/PhSun";
import "@phosphor-icons/webcomponents/PhTiktokLogo";
import "@phosphor-icons/webcomponents/PhTrashSimple";
import "@phosphor-icons/webcomponents/PhTwitchLogo";
import "@phosphor-icons/webcomponents/PhUser";
import "@phosphor-icons/webcomponents/PhWarning";
import "@phosphor-icons/webcomponents/PhWarningCircle";
import "@phosphor-icons/webcomponents/PhXCircle";
import "@phosphor-icons/webcomponents/PhXLogo";
import "@phosphor-icons/webcomponents/PhYoutubeLogo";
import "@phosphor-icons/webcomponents/PhEnvelope";
import "@phosphor-icons/webcomponents/PhCrown";
import "@phosphor-icons/webcomponents/PhSpeakerHigh";
import "@phosphor-icons/webcomponents/PhSpeakerSlash";

import { DataQueryController } from "ui-common";
import { appContext } from "ui-common/appContext";
import "ui-common/appContext.ts";
import "ui-common/theme";
import "ui-components/menu-button";
import "ui-components/notification/notification-manager";

import "./components/app-logo/app-logo";
import "./components/app-menu/app-menu";

import { router } from "./router";
import { initTelemetry } from "./telemetry";

import { isProduction } from "../../api/helpers/isProduction";
import { profileDataQueryOptions } from "../../profile/src/queries/profile-data";

declare global {
  interface Window {
    dataLayer?: unknown[];
  }
}

requestAnimationFrame(() => {
  if (isProduction()) {
    (function (w: Window & typeof globalThis, d: Document, s: string, l: string, i: string) {
      w.dataLayer = [];
      w.dataLayer.push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
      const f = d.getElementsByTagName(s)[0];
      const j = d.createElement(s) as HTMLScriptElement;
      const dl = l != "dataLayer" ? "&l=" + l : "";
      j.async = true;
      j.defer = true;
      j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
      f?.parentNode?.insertBefore(j, f);
    })(window, document, "script", "dataLayer", "GTM-PXCZQLNV");
  }
  initTelemetry();
});

@customElement("wow-app")
export class App extends LitElement {
  static override styles = css`
    :host {
      display: block;
      min-height: 100dvh;
      background: var(--sds-color-background-default-default);
      transition: background-color 0.2s ease;
    }
  `;

  profileDataController = new DataQueryController(this, () => profileDataQueryOptions);

  protected override willUpdate(): void {
    if (!appContext.currentUser) return;

    appContext.currentUser.avatarUrl =
      this.profileDataController.result.data?.profileImageUrl ?? appContext.currentUser.avatarUrl;
    appContext.currentUser.handle = this.profileDataController.result.data?.handle ?? appContext.currentUser.handle;
    appContext.currentUser.memberSinceDate =
      this.profileDataController.result.data?.memberSince ?? appContext.currentUser.memberSinceDate;
    appContext.currentUser.name = this.profileDataController.result.data?.name ?? appContext.currentUser.name;
  }

  protected override render() {
    return html`
      ${router}
      <notification-manager></notification-manager>
    `;
  }
}
